import React, { Component } from 'react'

class LogoSplash extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            fadeOut: false
        }
    }

    componentDidMount() {
        if (sessionStorage.getItem('doday_splash_shown')) {
            this.setState({ visible: false });
            if (this.props.onComplete) this.props.onComplete();
            return;
        }

        // Logo flies in (1.2s), holds (~1.2s), then cross-dissolve (1.5s)
        this.holdTimer = setTimeout(() => {
            this.setState({ fadeOut: true });
            sessionStorage.setItem('doday_splash_shown', 'true');
        }, 2400);

        this.removeTimer = setTimeout(() => {
            this.setState({ visible: false });
            if (this.props.onComplete) this.props.onComplete();
        }, 3900);
    }

    componentWillUnmount() {
        clearTimeout(this.holdTimer);
        clearTimeout(this.removeTimer);
    }

    render() {
        if (!this.state.visible) return null;

        return (
            <div className={"logo_splash" + (this.state.fadeOut ? " fade_out" : "")}>
                <img
                    src={process.env.PUBLIC_URL + "/image/logo_animation.png"}
                    className="logo_splash_img"
                    alt="DoDay"
                />
            </div>
        );
    }
}

export default LogoSplash;
